import React, { useState, useEffect, useCallback } from 'react';
import { Table, Button, Space, Popconfirm, message, Modal } from 'antd-v5';
import PageHeaderLayout from '../../component/page-header-layout';
import { PlusOutlined } from '@ant-design/icons';
import './index.less';
import Preview from './components/preview';
import AddTemplate from './components/addTemplate';
import { requestTagTemplateList, requestTagTemplateUpdateStatus } from '../../state/request/tag';

export const TEMPLATE_SOURCE_TYPE = {
  SYSTEM: 1,
  CUSTOM: 2,
};
export const TEMPLATE_TYPE = [
  { label: '系统预设', value: TEMPLATE_SOURCE_TYPE.SYSTEM },
  { label: '手动添加', value: TEMPLATE_SOURCE_TYPE.CUSTOM },
];
export const STATUS = [
  { label: '启用', value: true },
  { label: '禁用', value: false },
];

const LabelTemplateManagement = (props) => {
  const [list, setList] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [customOpen, setCustomOpen] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [editData, setEditData] = useState({});

  const getData = useCallback(async () => {
    const res = await requestTagTemplateList();
    if (res.code === 200) {
      setList(res.data);
    }
  }, []);

  useEffect(() => {
    getData();
  }, [getData]);

  // 停用启用
  const onConfirm = async (record) => {
    const { enable, id } = record;
    const res = await requestTagTemplateUpdateStatus({ templateId: id, enable: !enable });
    if (res.code === 200) {
      const txt = enable ? '禁用' : '启用';
      message.info(`${txt}模板成功`);
      getData();
    }
  };

  const columns = [
    {
      title: '模板名称',
      dataIndex: 'templateName',
    },
    {
      title: '备注',
      dataIndex: 'remark',
      ellipsis: true,
    },
    {
      title: '模板类型',
      dataIndex: 'sourceType',
      render: (sourceType) => TEMPLATE_TYPE.find((item) => item.value === sourceType)?.label,
    },
    {
      title: '状态',
      dataIndex: 'enable',
      width: 100,
      render: (enable) => (
        <span className={`dot ${enable ? 'green' : 'red'}`}>
          {STATUS.find((item) => item.value === enable)?.label}
        </span>
      ),
    },
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      width: 300,
      render: (_, record) => {
        const { enable, sourceType } = record;
        const txt = enable ? '禁用' : '启用';
        const isSystem = sourceType === 1;
        return (
          <Space wrap>
            <Button
              type='link'
              onClick={() => {
                setPreviewData(record);
                setPreviewOpen(true);
              }}
              style={{ color: '#01b755' }}
            >
              查看
            </Button>
            <Button
              type='link'
              onClick={() => {
                const newData = { ...record };
                setEditData(newData);
                setCustomOpen(true);
              }}
              disabled={isSystem}
              style={isSystem ? { color: 'rgba(0, 0, 0, 0.25)' } : { color: '#01b755' }}
            >
              编辑
            </Button>
            <Button
              type='link'
              onClick={() => {
                const newData = { ...record };
                delete newData.id;
                delete newData.templateName;
                setEditData(newData);
                setCustomOpen(true);
              }}
              style={{ color: '#01b755' }}
            >
              复制
            </Button>
            <Popconfirm
              title={`是否要${txt}模板`}
              onConfirm={() => onConfirm(record)}
              disabled={isSystem}
            >
              <span
                className='btn'
                style={
                  isSystem
                    ? { color: 'rgba(0, 0, 0, 0.25)' }
                    : enable
                    ? { color: 'red' }
                    : { color: '#01b755' }
                }
              >
                {txt}
              </span>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  return (
    <PageHeaderLayout>
      <div className='label-template-management'>
        <div style={{ marginBottom: 16, display: 'flex' }}>
          <Button
            onClick={() => {
              setEditData({});
              setCustomOpen(true);
            }}
            type='primary'
            icon={<PlusOutlined />}
          >
            添加模板
          </Button>
        </div>

        <Table dataSource={list} columns={columns} />

        <Modal
          title='模板预览'
          open={previewOpen}
          destroyOnClose
          onOk={() => setPreviewOpen(false)}
          onCancel={() => setPreviewOpen(false)}
          footer={null}
          width={1000}
        >
          <div style={{ padding: '64px 0' }}>
            <Preview {...(previewData ? JSON.parse(previewData.templateDetail) : {})} />
          </div>
        </Modal>
        <Modal
          title={`${editData.templateName ? '编辑' : '添加'}自定义标签模板`}
          open={customOpen}
          destroyOnClose
          onOk={() => setCustomOpen(false)}
          onCancel={() => setCustomOpen(false)}
          footer={null}
          width={1400}
          style={{ top: 20 }}
        >
          <AddTemplate
            editData={editData}
            onSaveSuccess={() => {
              getData();
              setCustomOpen(false);
            }}
          />
        </Modal>
      </div>
    </PageHeaderLayout>
  );
};

export default LabelTemplateManagement;
